<script lang="ts">
  // import Mapcat from "./_components/category-list.svelte";
  // import NoticeBar from "./_components/notice-bar.svelte";
  import UserQty from "./_components/user-qty.svelte";
  import ImageComp from "$components/image.svelte";
  import UspBanner from "$components/usp-banner.svelte";
  import TicketList from "./_components/ticket-list.svelte";
  import TicketBuy from "./_components/ticket-buy.svelte";
  import CatFilter from "./_components/category-filter.svelte";
  import SortProduct from "./_components/sort.svelte";
  import { browser } from "$app/environment";
  // import FilterTicket from "./_components/filter.svelte";
  import MapComponent from "./_components/map.svelte";
  import { isNavOpen } from "$lib/store/auth-context";
  import MetaComponent from "$components/meta/index.svelte";
  import { isLoading } from "$lib/store/loading-context";
  import { onNavigate } from "$app/navigation";
  import SeatedTogether from "./_components/seated-together.svelte";
  import PageHeaderComp from "./_components/page-header.svelte";
  import TrustpilotBottom from "$components/trustpilot/testimonials/quote.svelte";
  import RegisterInterest from "./_components/register-interest.svelte";
  import { FixtureManager } from "./_helper/fixture-manager";
  import type { IKlaviyoItem } from "$lib/klaviyo";
  import { openModal, Spinner } from "@thehood/svlib";
  import type { IFilterOption } from "./_helper/product-manager";
  import { onDestroy, onMount } from "svelte";
  import { INavMode, setNavMod } from "$lib/store/detect-view";
  import { ProductType, klaviyoViewedItemTracker } from "$lib/klaviyo";
  import type { IFixtureResp, INewProductUI, IEventDetails, ITicketBuy } from "./+page.server";
  // Set to hide nav as soon the page exsist
  setNavMod(INavMode.HIDE);
  isNavOpen.subscribe(v => {
    setNavMod($isNavOpen ? INavMode.FULL : INavMode.HIDE);
  });

  isLoading.set(true);

  export let data: IFixtureResp;

  let { products, rProds, eventDetails, subCategory, locale, cacheName, nav } = data;
  let rp = rProds || [];
  let needRefresh = new Set<string>(rp.map(v => v));
  let {
    i18nuuid,
    title,
    datetime,
    slug,
    venue,
    svgId: eventSvgId,
    performers,
    contentList,
    content,
    meta = [],
    season,
    tbc,
  } = eventDetails;

  let { title: venueTitle, svgId: venueSvg, image } = venue;
  $: svgId = eventSvgId ? eventSvgId : venueSvg;
  $: svgUrl = `/z/fixture/${svgId}/venue.svg`;

  const fixtureManager = new FixtureManager(i18nuuid, subCategory.slug, slug, products);
  let displayList = fixtureManager.displayList;

  // // Tracking
  function trackEventView(eventDetails: IEventDetails) {
    if (eventDetails) {
      const item: IKlaviyoItem = {
        ProductName: eventDetails.title,
        ProductID: eventDetails.i18nuuid,
        Categories: [ProductType.Fixture],
        ProductURL: document.URL,
      };
      klaviyoViewedItemTracker(item);
    }
  }

  // Ticket Buy
  let ticketToBuy: ITicketBuy = {
    productId: "",
    availability: 0,
    price: 0,
    currency: "GBP",
    note: "",
    block: [],
    ticketCategory: {},
    sellPreference: "",
    ticketFormat: "",
    customNotes: {},
    offerPrice: 0,
    singleSeat: false,
  };

  let toggleTicketBuy = false;

  function toggleTicketBuyFn() {
    toggleTicketBuy = !toggleTicketBuy;
  }

  function showTicketBuyFn(newItem: INewProductUI) {
    isLoading.set(true);
    // @TODO: - move this addTicket to page.svelte we don't need a listener for each LI
    // instead we want to have it on the UL
    // const { productid, availability, section, block, proceedprice } = liEl.dataset;
    const {
      productId,
      qty,
      proceedPrice,
      currency,
      sellPreference,
      ticketFormat,
      customNotes,
      offerPrice,
      ticketNotes,
      ticketRestrictions,
      ticketCategory,
      singleSeat,
    } = newItem;
    if (productId) {
      const url = new URL(document.URL);
      klaviyoViewedItemTracker({
        ProductID: productId,
        ProductName: `${eventDetails.title} ${ticketCategory.title}`,
        Categories: [ProductType.Ticket],
        ProductURL: document.URL,
        ImageURL: ticketCategory?.image?.path ? `${url.origin}${ticketCategory.image.path}` : undefined,
        ItemPrice: proceedPrice,
      });
    }

    ticketToBuy = {
      productId,
      availability: qty,
      price: proceedPrice,
      currency,
      note: [...ticketNotes, ...ticketRestrictions].map(v => v.title).join(", "),
      ticketCategory,
      sellPreference,
      block: newItem.block,
      ticketFormat: ticketFormat?.title,
      customNotes,
      offerPrice,
      singleSeat,
    } as ITicketBuy;

    toggleTicketBuyFn();
    isLoading.set(false);
  }

  const paths = [
    { name: "Home", url: "/" },
    { name: subCategory.title, url: subCategory.slug },
    { name: `${eventDetails.title} Tickets`, url: `${subCategory.slug}${eventDetails.slug}` },
  ];

  // Filter
  let filterArgs: IFilterOption = {
    category: "",
    together: false,
    userQty: 0,
  };

  let showCleanFilter = false;
  // Previous state to compare changes
  let prevFilterArgs: IFilterOption = { ...filterArgs };

  // Function to check if the object has changed
  function checkIfObjectChanged(newObj: IFilterOption, oldObj: IFilterOption) {
    for (let key in newObj) {
      if (newObj[key as keyof IFilterOption] !== oldObj[key as keyof IFilterOption]) {
        prevFilterArgs = { ...newObj };
        return true;
      }
    }
    return false;
  }

  $: {
    if (checkIfObjectChanged(filterArgs, prevFilterArgs)) {
      showCleanFilter = true;
    } else {
      showCleanFilter = false;
    }
  }

  function sortDirections(value: string) {
    fixtureManager.sortDirection(value);
    displayList = fixtureManager.displayList;
  }

  function chooseQty(userQty: number) {
    filterArgs.userQty = userQty;
    fixtureManager.runFilter(filterArgs);
    displayList = fixtureManager.displayList;
  }

  function resetFilter() {
    filterArgs.category = "";
    filterArgs.together = false;
    filterArgs.userQty = 0;
  }

  function clearFilter() {
    resetFilter();
    fixtureManager.cleanFilter();
    displayList = fixtureManager.displayList;
    showCleanFilter = false;
  }

  function toggleSeatLocation() {
    fixtureManager.cleanFilter();
    displayList = fixtureManager.displayList;
    openModal(CatFilter, {
      availableCategories: fixtureManager.getAvailableCategories,
      onConfirm: (args: IFilterOption) => {
        filterArgs.category = args.category;
        fixtureManager.runCategoriesFilter(filterArgs);
        displayList = fixtureManager.displayList;
      },
      onClose: () => {
        fixtureManager.runFilter({ reset: true });
        displayList = fixtureManager.displayList;
      },
    });
  }

  function onSeatTogetherClick(together: boolean) {
    filterArgs.together = together;
    fixtureManager.runFilter(filterArgs);
    displayList = fixtureManager.displayList;
  }

  function onSvgClick(ev: Event) {
    const retVal = fixtureManager.onSvgClick(ev, filterArgs);
    if (retVal?.block) {
      filterArgs.block = retVal?.block;
      filterArgs.category = [];
    }
    if (retVal?.category?.length) {
      filterArgs.block = "";
      filterArgs.category = retVal.category;
    }

    displayList = fixtureManager.displayList;
  }
  // Filter
  async function refreshProducts() {
    try {
      await fixtureManager.refresh(rProds, cacheName);
      displayList = fixtureManager.displayList;
    } catch (err) {
      console.log("Error on refresh");
    }
    // after refresh clear the waiting list
    needRefresh.clear();
  }

  async function pageInit() {
    browser && trackEventView(eventDetails);
    // Initially passing rProd here
    fixtureManager.init(products);
    displayList = fixtureManager.displayList;
    isLoading.set(false);
    rProds?.length && (await refreshProducts());
    // loadingRefresh only for event with no listing waiting to get latest
    loadingRefresh = false;
  }

  let changeLoad = false;
  let loadingRefresh = true;
  onMount(async () => {
    await pageInit();
  });

  onDestroy(() => {
    setNavMod(INavMode.FULL);
    fixtureManager.onDestroy();
    isLoading.set(false);
  });

  onNavigate(() => {
    changeLoad = true;
    isLoading.set(true);
  });

  // Bugfix - When navigating to another fixture, data on page isn't updating
  $: (async newData => {
    if (!changeLoad) {
      return;
    }
    const { products: a, rProds: b, eventDetails: c, subCategory: d, locale: e, cacheName: f, nav: g } = newData;
    products = a;
    rProds = b;
    eventDetails = c;
    subCategory = d;
    locale = e;
    cacheName = f;
    nav = g;

    rp = rProds || [];
    needRefresh = new Set<string>(rp.map(v => v));

    const {
      i18nuuid: h,
      title: i,
      datetime: j,
      slug: k,
      venue: l,
      svgId: m, //eventSvgId,
      performers: n,
      contentList: o,
      content: p,
      meta: q = [],
      season: r,
      tbc: s,
    } = eventDetails;
    i18nuuid = h;
    title = i;
    datetime = j;
    slug = k;
    venue = l;
    eventSvgId = m;
    performers = n;
    contentList = o;
    content = p;
    meta = q;
    season = r;
    tbc = s;

    const { title: t, svgId, image: i1 } = venue;
    venueTitle = t;
    venueSvg = svgId;
    image = i1;

    await pageInit();
  })(data);
</script>

<svelte:head>
  {#if svgId}
    <link rel="stylesheet" href="/z/fixture/{svgId}/styles.css" />
  {/if}
</svelte:head>

<MetaComponent {meta} />

<UspBanner />
<div class="fixture-wrapper">
  <PageHeaderComp {tbc} {title} {locale} {datetime} {venueTitle} {performers} {paths} {subCategory} {season} {nav} />
  <!-- Filter Desktop -->
  <div class="new-filter">
    {#if showCleanFilter}
      <button class="clear-filter mob-only" on:click={clearFilter}>Clear filter</button>
    {/if}
    <SortProduct {sortDirections} className="desk-only" />
    <UserQty {chooseQty} bind:selectedValue={filterArgs.userQty} />
    <SeatedTogether bind:together={filterArgs.together} onClick={onSeatTogetherClick} />
    <button on:click={toggleSeatLocation} class="seat-location">
      <i /><span class="pf-400">Seating locations</span>
    </button>
    {#if showCleanFilter}
      <button class="clear-filter" on:click={clearFilter}>Clear filter</button>
    {/if}
  </div>
  <!-- Filter Desktop-->
  <div id="fixture-details" bind:this={fixtureManager.fixtureContainer}>
    <div class="ticket-listing-wrapper">
      {#if displayList?.length}
        <div class="m-tickets">
          <h2 class="pf-700">Match Tickets</h2>
          <div class="mob-only">
            <SortProduct {sortDirections} />
          </div>
        </div>

        <div class="listing-outer">
          <ul class="tickets" class:toggle-ul-left={toggleTicketBuy}>
            {#each displayList as item (`${item.sku}${item.qty}${item.proceedPrice}`)}
              {@const [pl, _] = item.sku.split("-")}
              {@const loading = needRefresh.has(pl)}
              <TicketList {item} {locale} {showTicketBuyFn} {loading} />
            {/each}
          </ul>
          <TicketBuy bind:ticketToBuy {locale} {toggleTicketBuyFn} {toggleTicketBuy} {fixtureManager} />
        </div>
      {:else if !products.length}
        {#if loadingRefresh}
          <div style="padding-top:30%; padding-left:40%;">
            <Spinner />
          </div>
        {:else}
          <RegisterInterest {title} />
          }
        {/if}
      {:else}
        <div class="no-section pf-300">
          It seems we don't have any tickets available for this section at the moment. Please try removing any filters
          or choosing a different section. If you have a specific request, feel free to reach out to our customer
          service team.
        </div>
      {/if}
    </div>
    <div class="map-container">
      {#if svgId}
        <MapComponent {svgUrl} on:click={onSvgClick} onLoadComplete={fixtureManager.onSvgLoaded} />
        <!-- <Mapcat {products} /> -->
      {:else}
        <ImageComp {image} imgStyle="padding: 5%;" />
      {/if}
    </div>
  </div>
  <div class="content-grid content">
    <div class="trustpilot-wrapper">
      <h5 class="pf-800">Join Thousands of Happy Fans <i class="happy" /></h5>
      <TrustpilotBottom />
    </div>
    <div class="page-content">
      <h2 class="pf-700">{title} Match Day Tickets</h2>
      <div class="content-list generic-content">{@html content}</div>
      <div class="grid">
        {#each contentList as item}
          <div class="content-list generic-content">{@html item}</div>
        {/each}
      </div>
    </div>
  </div>
  <div
    class="backdrop"
    class:active={toggleTicketBuy}
    on:click={toggleTicketBuyFn}
    on:keyup={toggleTicketBuyFn}
    role="button"
    tabindex="0"
  ></div>
</div>

<style lang="scss">
  @use "./index.scss";
</style>
